import React from 'react';
import {useLocalization} from 'localization';
import type {Company} from 'services/companies';
import {CopyToClipboard, FlexBox, Spacer} from 'components';
import {useTextLabel, useTextValue} from 'schema/preview/hooks';

export const ContactSubPanel = (company: Company) => {
  const {t} = useLocalization();
  const TextValue = useTextValue();
  const TextLabel = useTextLabel();

  const publisherReminderBookEmails = (
    company.publisherReminderBookEmails ?? []
  ).filter(a => a && a !== company.contactInfoEmail);

  const publisherReminderOtherEmails = (
    company.publisherReminderEmails ?? []
  ).filter(a => a && a !== company.contactInfoEmail);

  return (
    <>
      {company.contactInfoEmail && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.email`)}
            </TextLabel>
            <Spacer width={0.5} />
            <FlexBox horizontal left center>
              <CopyToClipboard text={company.contactInfoEmail} size={'small'} />
              {company.contactInfoEmail}
            </FlexBox>
          </TextValue>
          <Spacer size={1} />
        </>
      )}

      {publisherReminderBookEmails.length > 0 && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.book`)}
            </TextLabel>
            <Spacer width={0.5} />
            {publisherReminderBookEmails.map(e => (
              <FlexBox key={e} horizontal left center>
                <CopyToClipboard text={e} size={'small'} />
                {e}
              </FlexBox>
            ))}
          </TextValue>
          <Spacer size={1} />
        </>
      )}

      {publisherReminderOtherEmails.length > 0 && (
        <>
          <TextValue>
            <TextLabel>
              {t(`page.metadata.manifestation.contact.otherTasks`)}
            </TextLabel>
            <Spacer width={0.5} />
            {publisherReminderOtherEmails.map(e => (
              <FlexBox key={e} horizontal left center>
                <CopyToClipboard text={e} size={'small'} />
                {e}
              </FlexBox>
            ))}
          </TextValue>
          <Spacer size={1} />
        </>
      )}
    </>
  );
};
